export default __webpack_public_path__ + "static/media/Today-Sales.31c83d03.svg";